import { Week } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

export function isCurrentWeekQuery(this: UiQueries, week: Week): boolean {
  if (this.uiState.currentWeekId == null) {
    return false;
  }

  if (
    week.weekId.startOfWeek.isSame(this.uiState.currentWeekId.startOfWeek) &&
    week.weekId.endOfWeek.isSame(this.uiState.currentWeekId.endOfWeek)
  ) {
    return true;
  }

  return false;
}
